<template>
  <div>
    <div class="tab_div">
      <van-tabs title-active-color="red" animated :line-width="3000">
        <van-tab v-for="(item, index) in list.caselist.casemenu" :key="index">
          <div class="tab-title" slot="title" @click="menucase(item.id)">
            {{ item.name }}
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="main">
      <!-- 频道列表 -->

      <div>
        <div class="case_main">
          <ul v-infinite-scroll="load" infinite-scroll-disabled="disabled">
            <li v-for="item in list.caselist.casecontent">
              <router-link to="" tag="a" @click.native="caseid(item.id)">
                <div class="list_main">
                  <img :src="item.img" />
                </div>

                <div class="case_word">
                  <h4 class="f14" v-html="item.name"></h4>
                  <p class="col_6 f12" v-html="item.scene"></p>
                </div>
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!--
          <div class="navlist">
            <ul>
              <li class="f14" v-for="item in list.caselist.casemenu" @click="menucase(item.id)" :class="list.selectid==item.id? 'active':''">
                   {{item.name}}
              </li>
            </ul>
          </div> -->

      <!-- <div class="case_main">
        <ul v-infinite-scroll="load" infinite-scroll-disabled="disabled">
          <li v-for="item in list.caselist.casecontent">
            <router-link to="" tag="a" @click.native="caseid(item.id)">
              <div class="list_main">
                <img :src="item.img" />
              </div>

              <div class="case_word">
                <h4 class="f14" v-html="item.name"></h4>
                <p class="col_6 f12" v-html="item.scene"></p>
              </div>
            </router-link>
          </li>
        </ul>
      </div> -->

      <div class="loding" v-if="list.loading">
        <i class="el-icon-loading"></i>
        <p class="el-loading-text f12">加载中</p>
      </div>
      <div class="loding" v-if="noMore">
        <p class="el-loading-text f12">没有更多了</p>
      </div>
    </div>
  </div>
</template>

<script>
import wxapi from "../../public/wxapi.js";
export default {
  data() {
    return {
      list: {
        selectid: "", //选择栏目index
        loading: false,
        page: 4,
        sum: 0,
        caselist: {
          casemenu: [
            {
              id: "",
              name: ""
            }
          ],
          casecontent: []
        }
      }
    };
  },
  methods: {
    // 分享
    wxRegCallback() {
      // 用于微信JS-SDK回调
      this.wxShareTimeline();
      this.wxShareAppMessage();
    },
    wxShareTimeline() {
      // 微信自定义分享到朋友圈
      let option = {
        title: "客户案例", // 分享标题, 请自行替换
        desc: "石家庄飞天科技开发有限公司", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        success: () => {
          // alert("分享成功");
        },
        error: () => {
          // alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareTimeline(option);
    },
    wxShareAppMessage() {
      // 微信自定义分享给朋友
      let option = {
        title: "客户案例", // 分享标题, 请自行替换
        desc: "石家庄飞天科技开发有限公司", // 分享描述, 请自行替换
        link: window.location.href, // 分享链接，根据自身项目决定是否需要split
        success: () => {
          // alert("分享成功");
        },
        error: () => {
          // alert("已取消分享");
        }
      };
      // 将配置注入通用方法
      wxapi.ShareAppMessage(option);
    },
    load() {
      this.list.loading = true;
      setTimeout(async () => {
        var dt = await this.$axios.post("/api/itemmore", {
          menu: this.list.selectid,
          type: 2,
          amount: 2,
          page: parseInt(this.list.page) + 1
        });
        dt.data = JSON.parse(dt.data);

        if (dt.status == 200) {
          if (dt.data.code !== 0) {
            this.$message({
              type: "info",
              message: dt.data.msg
            });
            return;
          }
        } else {
          alert(dt.statusText);
          return;
        }
        // console.log(dt)
        for (var i = 0; i < dt.data.data.data.length; i++) {
          this.list.caselist.casecontent.push(dt.data.data.data[i]);
        }
        this.list.page = dt.data.data.page;
        // console.log(this.list.caselist.casecontent.length, this.list.sum)
        this.list.loading = false;
      }, 1000);
    },

    //获取初始数据
    async getcase() {
      var dt = await this.$axios.get("/api/webcase");
      dt.data = JSON.parse(dt.data);
      if (dt.status == 200) {
        if (dt.data.code !== 0) {
          this.$message({
            type: "info",
            message: dt.data.msg
          });
          return;
        }
      } else {
        alert(dt.statusText);
        return;
      }
      // console.log(dt.data)
      // console.log(dt.data.data)
      // console.log(dt.data.data.casecontent[0].id)
      // this.list.caselist=dt.data.data
      this.list.caselist.casemenu = dt.data.data.casemenu;
      this.list.caselist.casecontent = dt.data.data.casecontent;
      this.list.sum = dt.data.data.sum;
      this.list.selectid = dt.data.data.casemenu[0].id;
      // this.$router.push({
      //         name: 'mecase', params: {
      //           id: this.list.selectid + '.html'
      //         }
      //       })
    },

    //菜单切换
    async menucase(index) {
      // this.list.selectid=index
      // this.$router.push({
      //   name: 'mecase', params: {
      //     id: index + '.html'
      //   }
      // })
      var dt = await this.$axios.post("/api/webcasecut", {
        menu: index
      });
      dt.data = JSON.parse(dt.data);
      if (dt.status == 200) {
        if (dt.data.code !== 0) {
          this.$message({
            type: "info",
            message: dt.data.msg
          });
          return;
        }
      } else {
        alert(dt.statusText);
        return;
      }
      // console.log(dt.data)
      this.list.caselist.casecontent = dt.data.data.casecontent;
      this.list.sum = dt.data.data.sum;
      this.list.selectid = index;
    },

    caseid(val) {
      this.$router.push({
        name: "medetails",
        params: {
          id: val + ".html",
          casemenu: this.list.selectid
        }
      });
    }
  },
  created() {
    this.getcase();
  },
  mounted() {
    wxapi.wxRegister(this.wxRegCallback);
  },
  // updated:function(){
  //        window.scroll(0, 0);
  //       },
  computed: {
    noMore() {
      // console.log( this.list.sum)
      // console.log( this.list.caselist.casecontent.length)
      return this.list.caselist.casecontent.length >= this.list.sum;
    },
    disabled() {
      return this.list.loading || this.noMore;
    }
  }
  // watch:{
  //   $route(to,from){
  //     this.menucase(this.$route.params.id.split('.')[0]);
  //     console.log(this.$route.params.id)
  //   },
  // }
};
</script>

<style lang="less" scoped>
.tab_div {
  position: fixed;
  top: 0;
  width: 100%;
  max-width: 640px;
  z-index: 2;

  /deep/.van-tabs {
    .van-tab {
      padding: 0;
      flex-basis: 25% !important;
    }

    .van-tab--active {
      font-size: 16px;
      font-weight: 600;
    }

    .van-tabs__line {
      display: none;
    }
    .van-tab {
      line-height: 55px;
      height: 55px;
    }

    .van-tabs__nav {
      background-color: #f5f5f5;
      padding-bottom: 0;
      height: 55px;
    }

    .van-tabs__wrap {
      height: 55px;
      padding: 0 10px;
      max-width: 620px;
    }
  }
}
.main {
  .navlist {
    ul {
      overflow: hidden;
      line-height: 60px;
      li {
        float: left;
        width: 25%;
        text-align: center;
        color: #797880;
      }
      .active {
        color: #e50012;
        font-size: 18px;
      }
    }
  }
  .top_txt {
    text-align: center;
    padding: 20px 0;
    font-size: 24px;
    color: #333;
    position: relative;
  }

  .top_txt:before {
    content: "";
    position: absolute;
    left: 50%;
    bottom: 5px;
    display: block;
    width: 64px;
    height: 3px;
    background: #e50012;
    margin-left: -32px;
  }

  .case_main {
    margin-top: 55px;
    ul {
      overflow: hidden;
      margin: 0 5px;
      /* background:url(../../assets/images/successfulcase.jpg); */

      li {
        box-shadow: 0 2px 5px 0 #eaeaea;
        width: 48%;
        overflow: hidden;
        float: left;
        border-radius: 5px;
        box-sizing: border-box;
        margin: 1%;

        @media (max-width: 480px) {
          .list_main {
            height: 120px;
          }
        }

        @media (min-width: 480px) and (max-width: 2000px) {
          .list_main {
            height: 200px;
          }
        }

        .list_main {
          overflow: hidden;
          box-sizing: border-box;
          background: #fff;
          opacity: 0.9;
          position: relative;
          /* border:4px solid #dbdbdb; */
          border-radius: 5px;

          img {
            width: 100%;
          }

          .hover {
            width: 100%;
            height: 30px;
            position: absolute;
            bottom: 0;
            left: 0;
            opacity: 0.8;
            background: #ccc;
          }
        }

        .case_word {
          min-height: 80px;
          text-align: left;
          padding: 5px 10px;
          overflow-y: hidden;
          box-sizing: border-box;
          background: #fff;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;

          h4 {
            font-weight: bold;
            line-height: 20px;
            height: 38px;
            margin-top: 3px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }

          p {
            white-space: nowrap;
            overflow: hidden;
            padding: 5px 0;
            text-overflow: ellipsis;
          }
        }
      }
    }
  }

  .loding {
    text-align: center;
    color: #999;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/move/case.vue